import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const AnswerDetail = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius};
  ${({ theme, pro }) =>
    (pro ? `box-shadow: 0px 0px 16px #3c44d740, 0 0 0 3px ${theme.mainColor};` : `box-shadow: ${theme.boxShadow};`)};
  margin-bottom: 36px;
  background: #fff;

  ${minMediaQueries.phablet`
    z-index: 1;
  `};

  ${maxMediaQueries.phablet`
    ${({ pro }) => pro && 'margin-left: 3px; margin-right: 3px;'};
  `};
`;
